// @flow
const previewViewStyles = {
  container: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 800,
    margin: '0 auto'
  }),

  header: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  }),

  title: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary
  }),

  rowCount: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.success.main
  }),

  checkIcon: (theme: Object) => ({
    fontSize: 20
  }),

  alert: (theme: Object) => ({
    marginBottom: theme.spacing(2)
  }),

  mappingSection: (theme: Object) => ({
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  }),

  sectionTitle: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5)
  }),

  sectionSubtitle: (theme: Object) => ({
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2)
  }),

  mappingGrid: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  }),

  mappingRow: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  }),

  csvColumn: (theme: Object) => ({
    minWidth: 150,
    fontWeight: 500,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  }),

  arrow: (theme: Object) => ({
    color: theme.palette.text.secondary,
    fontWeight: 500
  }),

  selectControl: (theme: Object) => ({
    minWidth: 180
  }),

  select: (theme: Object) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider
    }
  }),

  previewSection: (theme: Object) => ({
    marginBottom: theme.spacing(3)
  }),

  tableContainer: (theme: Object) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    maxHeight: 300,
    overflowY: 'auto'
  }),

  table: (theme: Object) => ({
    minWidth: 650
  }),

  tableHeaderCell: (theme: Object) => ({
    backgroundColor: theme.palette.background.default,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    position: 'sticky',
    top: 0,
    zIndex: 1
  }),

  mappedLabel: (theme: Object) => ({
    display: 'block',
    color: theme.palette.primary.main,
    fontWeight: 400
  }),

  tableCell: (theme: Object) => ({
    whiteSpace: 'nowrap',
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }),

  actions: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  })
};

export default previewViewStyles;
